export const DRIVER_LICENCE_DOC_TYPE = 1
export const PASSPORT_DOC_TYPE = 2
export const PHOTO_ID_CARD_DOC_TYPE = 7

export const idDocsConstants = {
  [DRIVER_LICENCE_DOC_TYPE]: 'Driver Licence',
  [PASSPORT_DOC_TYPE]: 'Passport',
  [PHOTO_ID_CARD_DOC_TYPE]: 'Photo ID Card',
}
